import React from "react";
import PropTypes from "prop-types";
import { QA_MALT } from "@xingternal/malt-constants";
import { getMatchedMedia, testable } from "@xingternal/malt-util";
const TestableDiv = testable(QA_MALT, "div");

import styles from "./Ad.css";

import { AdStatus, BannerTypes } from "./constants";
import advertize from "./advertize";
import { injectIntl, intlShape } from "react-intl";

class Ad extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.id + "-" + props.bannerType,
      status: AdStatus.PENDING,
      adSize: undefined,
      data: undefined
    };
  }

  componentDidMount() {
    let { bannerType, reloading, adIndex } = this.props;
    let fullBannerType = bannerType;

    if (reloading && !fullBannerType.endsWith("_RL")) {
      bannerType = bannerType + "_RL";
    }

    this.props.registerAd({
      id: this.state.id,
      component: this,
      bannerType,
      adIndex
    });
  }

  onStatusChanged(adProviderData) {
    const { status, adType, adSize } = adProviderData;
    const { id } = this.state;
    this.setState((prevState, props) => {
      const data = { id, status, adType, adSize };

      // optional external ad status callback
      if (this.props.onStatusChange) {
        this.props.onStatusChange(data);
      }

      return { ...prevState, ...data };
    });
  }

  componentWillUnmount() {
    this.props.unregisterAd(this.state.id);
  }

  render() {
    const { testId, bannerType } = this.props;
    const { id, status } = this.state;
    const { intl: { formatMessage } } = this.props;
    const canRender =
      getMatchedMedia() === "nav" || getMatchedMedia() === "desktop";

    const hiddenAd = (
      <TestableDiv
        id={id}
        testId={testId}
        className={styles.hidden}
        data-banner-type={bannerType}
      />
    );

    // hidden case
    if (!canRender) {
      // this.props.destroyAd({
      //   id: id,
      // });
      // return (<div data-empty-ad />);
      return hiddenAd;
    }

    switch (status) {
      case AdStatus.PENDING:
      case AdStatus.EMPTY:
        return hiddenAd;
      case AdStatus.READY:
        return (
          <TestableDiv
            id={id}
            testId={testId}
            className={styles.show}
            data-banner-type={bannerType}
            data-banner-label={formatMessage({
              id: "A11Y_ADVERTISEMENT_FRAME_TITLE"
            })}
          />
        );
      default:
        throw new Error("Unknown Ad state:", status);
    }
  }
}

Ad.propTypes = {
  // manually set by user of component
  id: PropTypes.string.isRequired,
  onStatusChange: PropTypes.func,
  reloading: PropTypes.bool,
  testId: PropTypes.string,
  // given by createAdVariant()
  bannerType: PropTypes.oneOf(Object.keys(BannerTypes)).isRequired,
  // given by advertize()
  registerAd: PropTypes.func.isRequired,
  unregisterAd: PropTypes.func.isRequired,
  destroyAd: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  adIndex: PropTypes.number.isRequired
};

Ad.defaultProps = {
  adIndex: 1,
};

Ad.displayName = "Ad";

export default injectIntl(advertize(Ad));
